import HttpService from "./htttp.service";

class MeetingService {
  endpoint = 'meetings';

  getAll = async (payload = null) => {
    return await HttpService.get(`${this.endpoint}/`, payload);
  };

  get = async (id) => {
    return await HttpService.get(`${this.endpoint}/${id}`);
  };

  verifyKarkunAttendance = async (id) => {
    return await HttpService.get(`${this.endpoint}/verify-attendance?id=${id}`, {
      withCredentials: true,
    });
  };


  getSummary = async (id) => {
    return await HttpService.get(`${this.endpoint}/${id}/summary`);
  };

  getattendancemeeting = async (payload = null) => {
    return await HttpService.get(`${this.endpoint}/meetingwithsummary`, payload);
  };

  getById = async (id) => {
    return await HttpService.get(`${this.endpoint}/meetings/${id}`);
  };

  create = async (payload) => {
    return await HttpService.post(`${this.endpoint}/add`, payload);
  };

  update = async (id, payload) => {
    return await HttpService.put(`${this.endpoint}/${id}`, payload);
  }

  delete = async (id) => {
    return await HttpService.delete(`${this.endpoint}/${id}`);
  }
}

export default new MeetingService();
